<div class="table-wrapper">
    <table class="row-border hover table table-bordered com_table" style="width: 100%;" *ngIf="!DataLoading">
        <thead>
            <!-- <tr class="text-dark" style="border-left: 5px solid #F24800;"> -->
            <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
                <th scope="col" *ngIf="EnableMultiSelect" style="border-left: 5px solid var(--bs-primary);">
                    <input type="checkbox" *ngIf="tableData && tableData.length > 0;" [(ngModel)]="masterSelected"
                        (change)="toggleSelectAll()" />
                </th>
                <th *ngIf="enableActionColumn" class="text-center">{{ actionColumnLabel }}</th>
                <th scope="col" *ngIf="enableAutoSerial">SrNo</th>
                <th scope="col" *ngFor="let col of columns">{{col.colName}}</th>
                <th *ngIf="enableInlineButton"></th>
                <th *ngIf="enableCheckboxColumn">{{ checkboxColumnLabel }}</th>
            </tr>
        </thead>
        <tbody id="TemplateListBody">
            <ng-container *ngIf="tableData && tableData.length > 0; else noData">

                <!-- <tr *ngFor="let rows of tableData; let i = index" [style.border-left]="'5px solid #' + WCColors[i % WCColors.length]"> -->
                <tr *ngFor="let rows of tableData; let i = index"
                    [ngStyle]="toggleStatus && rows.isActive === 0 ? {'background-color': 'var(--ui-surface-subtle)'} : {}"
                    [ngClass]="toggleStatus && rows.isActive === 0 ? 'disable-hover':''">
                    <td *ngIf="EnableMultiSelect">
                        <input type="checkbox" [checked]="rows.isSelected"
                            (change)="onSelctionCheckboxChange($event,rows)">
                    </td>
                    <td class="text-center" *ngIf="enableActionColumn" style="overflow: visible; max-width: 30px;">
                        <div class="btn-group dots_dropdown">
                            <button type="button" class="dropdown-toggle" data-bs-toggle="dropdown"
                                data-display="static" aria-haspopup="true" aria-expanded="false"
                                (click)="positionDropdown($event)">
                                <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right shadow-lg">

                                <ng-container *ngFor="let option of actionOptions">

                                    <ng-container *ngIf="!option.action">
                                        <button class="dropdown-item" type="button"
                                            (click)="actionButtonClick(option.actionName,rows)">
                                            <i [ngClass]="option.actionIcon"></i> {{option.actionName}}
                                        </button>
                                    </ng-container>

                                    <ng-container *ngIf="toggleStatus && option.action">

                                        <ng-container
                                            *ngIf="rows.isActive === 0 && rows.isDeleted === 0 && option.action == 'enable'">
                                            <button class="dropdown-item" type="button"
                                                (click)="actionButtonClick(option.actionName,rows)">
                                                <i [ngClass]="option.actionIcon"></i> {{option.actionName}}
                                            </button>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="rows.isActive === 1 && rows.isDeleted === 0 && option.action == 'disable'">
                                            <button class="dropdown-item" type="button"
                                                (click)="actionButtonClick(option.actionName,rows)">
                                                <i [ngClass]="option.actionIcon"></i> {{option.actionName}}
                                            </button>
                                        </ng-container>



                                    </ng-container>

                                </ng-container>




                            </div>
                        </div>
                    </td>
                    <td style="max-width: 30px;" *ngIf="enableAutoSerial">{{i+1}}</td>

                    <td *ngFor="let col of columns" [style]="col.colStyle">
                        <div [ngClass]="enableBadge===col.colName? 'badge badge-secondary font-l':''"
                            [ngbTooltip]="getLowerCaseValue(rows,col.colData)"
                            [style.background-color]="enableBadge===col.colName? '#' + WCColors[i % WCColors.length]:''"
                            class="colDiv" [style]="col.colStyle">

                            <!-- Custom logic for Default column -->
                            <ng-container *ngIf="col.colData === 'isDefault'; else normalColumn">
                                <ng-container *ngIf="rows.isDefault === 1">
                                    <i class="fa-solid fa-check-circle text-success me-1"></i> Default
                                </ng-container>
                            </ng-container>

                            <!-- Normal rendering for other columns -->
                            <ng-template #normalColumn>
                                <ng-container *ngIf="col.enableRouting; else checkHtml">
                                    <a [routerLink]="[col.routing!.route,rows[col.routing!.id]]" [queryParams]="col.routing?.queryParams">{{ col.isDate ?
                                        (getLowerCaseValue(rows,col.colData) | date:'dd/MM/yyyy') :
                                        getLowerCaseValue(rows,col.colData) }}</a>
                                </ng-container>

                                <ng-template #checkHtml>
                                    <ng-container *ngIf="col.isHtml; else normalData">
                                        <span [innerHtml]="getLowerCaseValue(rows,col.colData)"></span>
                                    </ng-container>
                                </ng-template>

                                <ng-template #normalData>
                                    {{ col.isDate ? (getLowerCaseValue(rows,col.colData) | date:'dd/MM/yyyy') :
                                    getLowerCaseValue(rows,col.colData) }}
                                </ng-template>
                            </ng-template>

                        </div>
                    </td>


                    <td *ngIf="enableInlineButton">
                        <button type="button" class="btn-sm d-flex align-items-center justify-content-center"
                            [disabled]="rows.isLoading" [ngClass]="enableInlineButton.buttonClass"
                            (click)="enableInlineButton.actionHandler(rows)">

                            <!-- Spinner while this row is loading -->
                            <span *ngIf="rows.isLoading" class="spinner-border spinner-border-sm me-2" role="status"
                                aria-hidden="true">
                            </span>

                            <!-- Button text -->
                            {{ enableInlineButton.buttonName }}
                        </button>
                    </td>
                    <td *ngIf="enableCheckboxColumn" class="text-center">
                        <input type="checkbox" [(ngModel)]="rows[checkboxStateBinding]"
                            (change)="onCheckboxChange(rows)" [checked]="rows[checkboxStateBinding]===1" />
                    </td>




                </tr>

            </ng-container>


            <ng-template #noData>
                <tr>
                    <td [attr.colspan]="totalColumnCount" class="text-center text-muted py-4">
                        <i class="bi bi-inbox me-2"></i>No records found
                    </td>
                </tr>
            </ng-template>


        </tbody>
    </table>
    <table class="row-border hover table table-bordered com_table" style="width: 100%;" *ngIf="DataLoading">
        <thead>
            <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
</div>